import React, { Component } from "react";
import Keyboard from "./Keyboard";
import Key from "./Key";
import { Player } from "./sound";

const generateOctave = octave => [
  `C${octave}`,
  `C${octave}#`,
  `D${octave}`,
  `E${octave}b`,
  `E${octave}`,
  `F${octave}`,
  `F${octave}#`,
  `G${octave}`,
  `G${octave}#`,
  `A${octave}`,
  `B${octave}b`,
  `B${octave}`
];

const KEYS = [...generateOctave(4), ...generateOctave(5)];
const KEYS_MAP = {
  a: "C4",
  w: "C4#",
  s: "D4",
  e: "E4b",
  d: "E4",
  f: "F4",
  t: "F4#",
  g: "G4",
  y: "G4#",
  h: "A4",
  u: "B4b",
  j: "B4",
  A: "C5",
  k: "C5",
  W: "C5#",
  o: "C5#",
  S: "D5",
  l: "D5",
  E: "E5b",
  p: "E5b",
  D: "E5",
  ";": "E5",
  F: "F5",
  "'": "F5",
  T: "F5#",
  "]": "F5#",
  G: "G5",
  "\\": "G5",
  Y: "G5#",
  H: "A5",
  U: "B5b",
  J: "B5"
};

export default class KeyboardView extends Component {
  state = {
    activeKeys: {}
  };

  handleKeyDown = evt => {
    evt.preventDefault();
    const key = KEYS_MAP[evt.key];
    this.setState({
      activeKeys: {
        ...this.state.activeKeys,
        [key]: true
      }
    });
    Player.playNote(key);
  };

  handleKeyUp = evt => {
    const lowerKey = KEYS_MAP[evt.key.toLowerCase()];
    const upperKey = KEYS_MAP[evt.key.toUpperCase()];
    this.setState({
      activeKeys: {
        ...this.state.activeKeys,
        [lowerKey]: false,
        [upperKey]: false
      }
    });
    Player.stopNote(lowerKey);
    Player.stopNote(upperKey);
  };

  handleMouseUp = () => {
    this.setState({
      activeKeys: {}
    });
    Player.stopAllNotes();
  };

  handleMouseDown = key => {
    Player.playNote(key);
    this.setState({
      activeKeys: {
        ...this.state.activeKeys,
        [key]: true
      }
    });
  };

  componentDidMount() {
    this.keydownListener = document.addEventListener(
      "keydown",
      this.handleKeyDown
    );
    this.keyupListener = document.addEventListener("keyup", this.handleKeyUp);
    this.mouseupListener = document.addEventListener(
      "mouseup",
      this.handleMouseUp
    );
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keydownListener);
    document.removeEventListener("keyup", this.keyupListener);
    document.removeEventListener("mouseup", this.mouseupListener);
  }

  render() {
    const { activeKeys } = this.state;
    return (
      <Keyboard>
        {KEYS.map(key => (
          <Key
            key={key}
            active={!!activeKeys[key]}
            value={key}
            onMouseDown={this.handleMouseDown}
          />
        ))}
      </Keyboard>
    );
  }
}
